import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { ItemCardHeaderProps } from './type'

import { LocalShippingFilledIcon } from '@/components/icons/LocalShippingFilled'
import { Icon } from '@/components/ui'
import { ITEM_CARD_STATUS_LABEL } from '@/const'

export const ItemCardHeader = ({ item }: ItemCardHeaderProps) => {
  const { t } = useTranslation()
  const categoryName = useMemo(() => {
    if (item.categories === null || item.categories.length === 0) return ''
    return item.categories[item.categories.length - 1].categoryName ?? ''
  }, [item.categories])

  const itemStatusLabel = useMemo(() => {
    return ITEM_CARD_STATUS_LABEL[item.itemStatus]
  }, [item.itemStatus])

  return (
    <div
      className={clsx(
        'tw-w-full',
        'tw-flex tw-flex-col tw-justify-between',
        'tw-overflow-hidden'
      )}
    >
      <p className={clsx('tw-text-xs', 'tw-truncate')}>{categoryName}</p>
      <p className={clsx('tw-text-xs', 'tw-mt-1 tw-truncate')}>
        {item.brandName}
      </p>
      <p
        className={clsx(
          'tw-text-sm tw-font-bold',
          'tw-mt-1 tw-line-clamp-2 tw-break-all'
        )}
      >
        {item.itemName}
      </p>
      <p className={clsx('tw-text-xs', 'tw-mt-1 tw-truncate')}>
        {`${t('item.detail.salonPrice')}：${(
          item.salonPrice || 0
        ).toLocaleString()} ${t('common.label.yen')}`}
      </p>

      {item.isBackorder && (
        <p
          className={clsx(
            'tw-mt-1 tw-flex tw-items-center tw-justify-start tw-text-xs'
          )}
        >
          <Icon icon={LocalShippingFilledIcon} size={'lg'} />
          <span className="tw-ml-1">{t('item.list.backorder')}</span>
        </p>
      )}

      {itemStatusLabel && (
        <div>
          <p className={clsx('tw-mt-1 tw-text-sm tw-text-alert-500')}>
            {itemStatusLabel}
          </p>
        </div>
      )}
    </div>
  )
}
